import { extends as _extends } from '../../_virtual/_rollupPluginBabelHelpers.js';
import React from 'react';
import { PropertySearch as PropertySearch$1 } from '@zillow/zrs-cms';
import PropTypes from 'prop-types';

var PROPERTY_SEARCH_CONFIG_VALUES = {
  test: {
    origin: 'https://www.qa.zillow.net',
    graphURL: 'https://zg-graph-stage.int.zgcp-federated-nonprod-k8s.zg-int.net/graphql/'
  },
  prod: {
    origin: 'https://www.zillow.com',
    graphURL: 'https://www.zillow.com/graphql/'
  }
};
var BlockPropertySearch = function BlockPropertySearch(_ref) {
  var attrs = _ref.attrs;
  var NEXT_PUBLIC_ENV = process.env.NEXT_PUBLIC_ENV;
  return /*#__PURE__*/React.createElement(PropertySearch$1, _extends({
    opensInNewWindow: true,
    propertySearchConfigValues: PROPERTY_SEARCH_CONFIG_VALUES[NEXT_PUBLIC_ENV] || PROPERTY_SEARCH_CONFIG_VALUES.test
  }, attrs));
};
BlockPropertySearch.propTypes = process.env.NODE_ENV !== "production" ? {
  attrs: PropTypes.shape({
    id: PropTypes.string,
    placeholder: PropTypes.string,
    size: PropTypes.oneOf(['sm', 'md', 'lg']),
    categories: PropTypes.arrayOf(PropTypes.oneOf(['buy', 'rent', 'sell', 'zestimate'])),
    t: PropTypes.string,
    opensInNewWindow: PropTypes.bool
  }),
  index: PropTypes.number
} : {};
var PropertySearch = BlockPropertySearch;

export { PROPERTY_SEARCH_CONFIG_VALUES, PropertySearch as default };
